import $ from 'jquery';
import BaseComponent from './baseComponent';

/**
 * Provides functionality related to the Newsroom.
 */
export default class Newsroom extends BaseComponent {
  /**
     * @param options
     */
  constructor(options) {
    super(options);
    this.$isDataNewsroom = $('[data-newsroom]');
    this.$loadMoreButton = $('[data-load-more-news]');
    this.$loadingIndicator = $('[data-loading-indicator]');
    this.$filterItems = $('[data-newsroom-filter-item]');
    this.$mobileFilterSelect = $('[data-newsroom-filter-select]');
    this.videoController = options.video;
    this.textController = options.textController;

    // The page offset and taxonomy term id used to load the news via ajax.
    this.page = 0;
    this.taxonomyTermId = $('[data-taxonomy-term-id]') ? parseInt($('[data-taxonomy-term-id]').data('taxonomy-term-id'), 10) : 0;
    this.apiUrl = `/${$('html')[0].lang}/newsroom/api`;
  }

  init() {
    // Do not initialize newsroom logic if there is no newsroom
    if (!this.$isDataNewsroom) {
      return;
    }

    this.initFilters();
    this.initMobileFilter();
    this.loadInitialStream();
    this.initLoadMoreNews();
  }

  /**
     * Initially load the stream news.
     *
     * Checks if a hash from a keyword is present in the URL and loads only
     * news from the given keyword. By default, news of all keywords are displayed.
     */
  loadInitialStream() {
    if (window.location.hash) {
      const keyword = decodeURIComponent(window.location.hash).substr(1).replace(/\s/g, '-');
      const $filterItem = this.$filterItems.filter(`[title="${keyword}"]`);
      if ($filterItem.length) {
        this.taxonomyTermId = $filterItem.length ? parseInt($filterItem.data('term-id'), 10) : 0;
        this.activateFilterItem($filterItem);
      }
    }

    this.loadNews();
  }

  /**
     * Handle the loading of additional news when clicking the "load more news" button.
     */
  initLoadMoreNews() {
    this.$loadMoreButton.on('click', (event) => {
      event.preventDefault();
      this.page += 1;
      this.loadNews();
    });
  }

  /**
     * Setup the keywords filter navigation.
     */
  initFilters() {
    this.$filterItems.on('click', (event) => {
      event.preventDefault();
      const $filterItem = $(event.target);

      // Do not load news if we click on the current active item.
      if ($filterItem.hasClass('-active')) {
        return;
      }

      // Get the taxonomy term of the clicked kewyord.
      this.taxonomyTermId = parseInt($filterItem.data('term-id'), 10);
      this.handleFilterChange();
    });
  }

  /**
     * Setup the keyword filter navigation for mobile, based on a select-element.
     */
  initMobileFilter() {
    const select = this.$mobileFilterSelect[0];

    this.$mobileFilterSelect.on('change', () => {
      const option = select.options[select.selectedIndex];
      this.taxonomyTermId = parseInt(option.value, 10);
      this.handleFilterChange();
    });
  }

  /**
     * Handle a change of the filters. Can be called by mobile-select-change or
     * desktop-list-change.
     */
  handleFilterChange() {
    const $filterItem = $(`[data-term-id=${this.taxonomyTermId}]`);

    // Activate the current & correct filter items (select & list)
    this.activateFilterItem($filterItem);

    // Reset page counter
    this.page = 0;

    window.location.hash = $filterItem.attr('title').replace(/\s/g, '-');

    // Hide any present news.
    $('[data-news-container]').hide();

    // Load new news
    this.loadNews();
  }

  /**
     * Call newsroom API to load the next page of news via ajax into the stream.
     */
  loadNews() {
    this.$loadingIndicator.show();
    this.$loadMoreButton.hide();

    // The freshly loaded news are wrapped by this container.
    const $container = $('<div data-news-container></div>');
    $container.insertBefore(this.$loadingIndicator);

    $container.load(`${this.apiUrl}?page=${this.page}&taxonomyTermId=${this.taxonomyTermId}`, (response) => {
      this.$loadingIndicator.hide();

      // If no news are returned, we do not show the button to load more.
      const hasNews = $(response).filter('[data-news-stream]').length > 0;
      if (hasNews) {
        this.$loadMoreButton.show();
      }

      // Init videos
      this.videoController.init();

      // Update text Ellipsis
      this.textController.updateContent();
    });
  }

  /**
     * Activate the given filter item, e.g. toggle active class.
     *
     * @param $filterItem
     */
  activateFilterItem($filterItem) {
    // Handle nav-list-filters
    this.$filterItems.removeClass('-active');
    $filterItem.addClass('-active');

    // Handle mobile-select-filter
    this.$mobileFilterSelect[0].value = this.taxonomyTermId;
  }
}
